//A few exceptions for tracking-classification
export enum TrackingCategory {
  AKTION_AUSWAHL = 'Aktion_Auswahl',
  NAVIGATION = 'Navigation',
  SPEICHERN = 'Speichern'
}

export enum TrackingAktion {
  T_BUTTON = 'Button',
  T_BOOLEAN = 'Boolean',
  T_LIST = 'Liste'
}

export enum TrackingName {
  WEITER = 'Weiter',
  ZURUECK = 'Zurück'
}
